import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';
import _ from 'lodash';
import { bindActionCreators } from 'redux';

import ProfileCard from 'PointOfSale/modules/individualServing/component/ProfileCard';
import LookUpNavigationContainer from 'PointOfSale/modules/lookup/container/LookUpNavigationContainer';
import QueueContainer from 'PointOfSale/modules/queue/container/QueueContainer';
import LastTransactionDetails from 'PointOfSale/modules/common/container/LastTransactionDetails';
import { SessionTypes } from 'PointOfSale/modules/common/constants';
import * as POSSelectors from 'PointOfSale/selectors';
import * as QueueActions from 'PointOfSale/modules/queue/state/actions';
import * as TeacherActions from 'PointOfSale/modules/teacher/state/actions';
import * as MealCounterActions from 'PointOfSale/modules/cepCard/state/actions';
import * as OtherActions from 'PointOfSale/modules/other/state/actions';

class ProfileCardContainer extends React.Component {
  removeFromQueue = () => {
    const {
      activeSession,
      hasMealCounterSession,
      QueueActions,
      MealCounterActions,
    } = this.props;

    if (SessionTypes.Queue === activeSession) {
      if (hasMealCounterSession) {
        MealCounterActions.removeStudent();
      } else {
        QueueActions.removeFromQueueAudit();
        QueueActions.removeFromQueue();
      }
    }
  };

  removeFromOther = () => {
    const { OtherActions } = this.props;
    OtherActions.remove();
  };

  removeFromTeacher = () => {
    const { currentProfile, TeacherActions } = this.props;
    const idSeed = _.get(currentProfile, 'profile.IdSeed');
    if (idSeed) {
      TeacherActions.removeFromTeacher(idSeed);
    }
  };

  activeSessionSettings = {
    [SessionTypes.Queue]: {
      onClick: this.removeFromQueue,
      messageText: 'Would you like to remove this student from the queue?',
    },
    [SessionTypes.Teacher]: {
      onClick: this.removeFromTeacher,
      messageText: 'Would you like to unselect this student?',
    },
  };

  getDeleteButtonSettings = () => {
    const { activeSession } = this.props;

    const baseSettings = {
      icon: 'trash',
      size: 'large',
      color: 'red',
      className: 'overlay-top-right circular inverted',
      showPopup: true,
      position: 'bottom left',
    };

    return activeSession
      ? {
          ...baseSettings,
          ...this.activeSessionSettings[this.props.activeSession],
        }
      : undefined;
  };

  render() {
    const {
      activeSession,
      amountPaid,
      change,
      currentProfile,
      totalCost,
      subtotal,
      tax,
      isTaxRate,
      pendingBalance,
    } = this.props;

    const showQueue = SessionTypes.Queue === activeSession;

    return (
      <React.Fragment>
        <div className="flex flex-col">
          <LookUpNavigationContainer />
          <ProfileCard
            currentProfile={currentProfile.profile}
            totalCost={totalCost}
            subtotal={subtotal}
            tax={tax}
            isTaxRate={isTaxRate}
            change={change}
            amountPaid={amountPaid}
            activeSession={activeSession}
            deleteButtonSettings={this.getDeleteButtonSettings()}
            pendingBalance={pendingBalance}
          />
        </div>
        {showQueue && (
          <div className="flex flex-col flex-1 flex-min-height-bug-fix">
            <QueueContainer />
            <LastTransactionDetails />
          </div>
        )}
      </React.Fragment>
    );
  }
}

ProfileCardContainer.propTypes = {
  currentProfile: PropTypes.object,
};

const mapStateToProps = state => ({
  currentProfile: POSSelectors.getCurrentProfile(state),
  activeSession: POSSelectors.getActiveSession(state),
  totalCost: POSSelectors.getCurrentTransactionCost(state),
  subtotal: POSSelectors.getCurrentTransactionSubtotal(state),
  tax: POSSelectors.getCurrentTransactionTax(state),
  isTaxRate: !!POSSelectors.getCurrentTaxRate(state),
  pendingBalance: POSSelectors.getCurrentTransactionPendingBalance(state),
  change: POSSelectors.getCurrentTransactionChange(state),
  amountPaid: POSSelectors.getCurrentTransactionAmountPaid(state),
  hasMealCounterSession: POSSelectors.hasMealCounterSession(state),
});

const mapDispatchToProps = dispatch => ({
  QueueActions: bindActionCreators(QueueActions, dispatch),
  MealCounterActions: bindActionCreators(MealCounterActions, dispatch),
  TeacherActions: bindActionCreators(TeacherActions, dispatch),
  OtherActions: bindActionCreators(OtherActions, dispatch),
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(ProfileCardContainer);



// WEBPACK FOOTER //
// ./src/pages/pointofsale/modules/individualServing/container/ProfileCardContainer.js